import React from "react";
import styles from "./styles.module.scss";
import {TextBold14, TextMedium16, ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import LazyAssets from "@/app/utils/assets_widget";
import UserRowWidget from "@/app/components/user_row_widget";
import Button from "@/app/components/button";
import TextButton from "@/app/components/text_button/widget";
import Chip from "@/app/components/chip";
import MapWithRadiusAndPoint from "@/app/components/map_static_with_radius_and_point";
import {NearbyUsersModel} from "@/app/api/user";
import {CourtBigModel} from "@/app/api/courts";
import {useMediaQuery} from "@/app/utils/custom_function";
import CourtInfoWidget from "@/app/components/court_info_widget/widget";
import {ReviewModel} from "@/app/api/reviews";

interface Props {
  toggleSelectUser?: () => void;
  goToSelectMap?: () => void;
  users?: NearbyUsersModel[] | undefined;
  location?: CourtBigModel | undefined;
  reviews?: ReviewModel[]
}

const UsersAndLocation: React.FC<Props> = ({toggleSelectUser, goToSelectMap, users, location, reviews}) => {
  const isDesktop = useMediaQuery('(min-width:1024px)');

  return (
    <>
      <div className={styles.usersBlock}>
        <div className={styles.title} onClick={toggleSelectUser}>
          <ThirtyText text={t(s.youPlayWith)}/>
          {toggleSelectUser && <LazyAssets.Add className={styles.add}/>}
        </div>
        <div className={styles.users}>
          {users?.map((user) => (<UserRowWidget user={user} key={user.id} className={styles.user} onClick={() => {
          }} isDesktop={isDesktop}/>))}
          {(users ?? []).length === 0 && <div className={styles.notSelected}>
              <TextMedium16 text={t(s.usersNotSelected)}/>
            {toggleSelectUser && <Button text={t(s.selectUsers)} isViolet onClick={(toggleSelectUser)}/>}
          </div>}
        </div>
      </div>
      <div className={styles.locationBlock}>
        <div className={styles.title} onClick={() => {
        }}>
          <ThirtyText text={t(s.location)}/>
          {goToSelectMap && <TextButton text={t(s.change)} onClick={goToSelectMap} isMedium withUnderLine/>}
        </div>
        <div className={styles.location}>
          {!location && <div className={styles.notSelected}>
              <TextMedium16 text={t(s.courtNotSelected)}/>
            {goToSelectMap && <Button text={t(s.selectACourt)} isViolet onClick={goToSelectMap}/>}
          </div>}
          {location && !isDesktop && <>
              <div className={styles.mainInfo}>
                  <ThirtyText text={location.name}/>
                  <TextBold14 text={location.address} className={styles.address}/>
              </div>
              <div className={styles.chips}>
                {location?.type !== undefined && location?.type.length > 0 && location?.type.map((type) => (<Chip text={type}/>))}
                {location?.bookingRequired && <Chip text={t(s.bookingRequired)}/>}
                {location?.lockerRooms && <Chip text={t(s.lockerRooms)}/>}
                {location?.artificialLight && <Chip text={t(s.artificialLight)}/>}
                {location?.parkingAvailability && <Chip text={t(s.parkingAvailability)}/>}
              </div>
              <div className={styles.map}>
                  <MapWithRadiusAndPoint radiusKm={2} getCoords={() => {
                  }} coords={{latitude: location.latitude, longitude: location.longitude}}/>
              </div>
          </>}
          {location && isDesktop && <CourtInfoWidget data={location} reviews={reviews} goToCreateMatch={() => {
          }} courtOnMatch/>}
        </div>
      </div>
    </>
  );
};

export default UsersAndLocation;